import { Modal } from "antd";
import { useEffect } from "react";
import { useVersionReload } from "./useVersionReload";
import configuration from "utils/config";

const versionTimeLocalStorageKey = "versionReloadTime";

/** Check if the app is out of date. */
export function useVersionChecker() {
    const { data } = useVersionReload();
    let versionReloadTime = null;
    try {
        // get the last time the version was checked
        versionReloadTime = window.localStorage.getItem(versionTimeLocalStorageKey);
    } catch (err) {
        console.warn("Failed to get version reload time from local storage", err);
    }

    useEffect(() => {
        if (
            data.version !== configuration.version &&
            (versionReloadTime === null || new Date().getTime() - parseInt(versionReloadTime) > 10 * 60 * 1000)
        ) {
            try {
                // update the last time the version was checked
                window.localStorage.setItem(versionTimeLocalStorageKey, String(new Date().getTime()));
            } catch (err) {
                console.warn("Failed to set version reload time in local storage", err);
            }

            // force the user to update
            Modal.warn({
                title: "Update Required",
                content: "There has been an update. Refresh the page to get the latest version.",
                onOk: () => window.location.reload(),
                okText: "Update",
            });
        }
    }, [data, versionReloadTime]);
}
